import { safeParseJSON } from '@/utils/json-parse';

/**
 * 解析 containerDeployConfig 根对象（JSON 字符串或对象，可双重 stringify）。
 * 包级 pure：L1 / `_shared/workload-agg` / L2 均可消费。勿放进 `_shared/common` 再被 L1 直接依赖（L1 禁 common|image-network-linkage）。
 */
export function parseContainerDeployConfigObject(raw?: string | Record<string, unknown> | null): Record<string, unknown> {
  if (!raw) return {};
  let config: unknown = raw;
  if (typeof config === 'string') {
    config = safeParseJSON(config, {});
    if (typeof config === 'string') {
      config = safeParseJSON(config, {});
    }
  }
  return config && typeof config === 'object' && !Array.isArray(config) ? (config as Record<string, unknown>) : {};
}
